<template>
  <div class="contact-form">
    <b-row>
      <b-col cols="12" sm="10" class="mt-3 order-2 order-sm-1">
        <h3>{{ "Créer un nouveau contact" }}</h3>
      </b-col>
      <b-col cols="12" sm="2" class="mt-3 order-1 order-sm-2">
        <div class="d-flex justify-content-end">
          <div class="btn" @click="cancel"><font-awesome-icon icon="times" size="lg" /></div>
        </div>
      </b-col>
    </b-row>
    <!-- gender | lastname | firstname | email -->
    <b-row class="my-3 justify-content-center">
      <b-col cols="12">
        <b-row>
          <b-col cols="12" sm="6" md="4">
            <b-form-radio-group
              v-model="contact.entity_type"
              stacked
              class="custom-radio-checkbox ml-sm-5"
              @change="setEntityType(entityTypes.individual)"
            >
              <b-form-radio class="my-2 font-16" size="lg" :value="entityTypes.individual">
                Particulier</b-form-radio
              >
            </b-form-radio-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-radio-group
              v-model="contact.entity_type"
              stacked
              class="custom-radio-checkbox"
              @change="setEntityType(entityTypes.legal)"
            >
              <b-form-radio class="my-2 font-16" size="lg" :value="entityTypes.legal">
                Professionnel</b-form-radio
              >
            </b-form-radio-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-5 mb-sm-4 mx-sm-0">
      <b-col v-if="contact.entity_type == entityTypes.individual" sm="3" md="2">
        <label>{{ $t("general.Civilité") }}</label>
        <b-form-select
          :value="contact.gender"
          :options="genderOptions"
          @change="updateContact('gender', $event)"
        />
      </b-col>
      <b-col v-if="contact.entity_type == entityTypes.individual" sm="4" md="3">
        <label>{{ $t("general.Nom") }}</label>
        <ValidationProvider
          ref="vee-b-contact-lastname"
          v-slot="{ errors, classes }"
          :name="'nom'"
          rules="required"
        >
          <b-input :value="contact.lastname" @input="updateContact('lastname', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col v-if="contact.entity_type == entityTypes.individual" sm="4" md="3">
        <label>{{ $t("general.Prénom") }}</label>
        <b-input :value="contact.firstname" @input="updateContact('firstname', $event)" />
      </b-col>

      <b-col v-if="contact.entity_type == entityTypes.legal" sm="7" md="6">
        <label>Raison sociale</label>
        <ValidationProvider
          ref="vee-b-contact-lastname"
          v-slot="{ errors, classes }"
          :name="'raison sociale'"
          rules="required"
        >
          <b-input :value="contact.lastname" @input="updateContact('lastname', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>

      <b-col sm="6" md="4">
        <label>{{ $t("general.Email") }}</label>
        <ValidationProvider
          ref="vee-b-contact-email"
          v-slot="{ errors, classes }"
          :name="'email'"
          :rules="contact.contact_type == contactTypes.email ? 'required|email' : 'email'"
        >
          <b-input :value="contact.email" @input="updateContact('email', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <!-- street nb | street | address second -->
    <b-row class="mb-5 mb-sm-4 mx-sm-0">
      <b-col sm="6" md="6">
        <label>Adresse</label>
        <b-input :value="contact.address" @input="updateContact('address', $event)" />
      </b-col>
      <b-col sm="6" md="6">
        <label>{{ $t("general.Complément") }}</label>
        <b-input :value="contact.complement" @input="updateContact('complement', $event)" />
      </b-col>
    </b-row>
    <!-- zipcode | city | country -->
    <b-row class="mb-5 mb-sm-4 mx-sm-0">
      <b-col sm="3" md="2">
        <label>{{ $t("general.Code_postal") }}</label>
        <b-input :value="contact.zipcode" @input="updateContact('zipcode', $event)" />
      </b-col>
      <b-col sm="4" md="3">
        <label>Ville</label>
        <b-input :value="contact.city" @input="updateContact('city', $event)" />
      </b-col>
      <b-col sm="4" md="3">
        <label>{{ $t("general.Pays") }}</label>
        <ValidationProvider
          ref="vee-b-contact-country"
          v-slot="{ errors, classes }"
          :name="'pays'"
          rules="required"
        >
          <b-form-select
            :value="contact.country.toUpperCase()"
            :options="countryOptions"
            @input="updateContact('country', $event)"
          >
            <template #first>
              <b-form-select-option :value="''" disabled>Choisissez le pays</b-form-select-option>
            </template>
          </b-form-select>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>

      <b-col sm="5" md="4">
        <label>Complément 2</label>
        <b-input :value="contact.complement2" @input="updateContact('complement2', $event)" />
      </b-col>
    </b-row>
    <!-- contact type -->
    <b-row class="mb-4 mx-sm-0">
      <b-col sm="6" md="5">
        <label>{{ $t("general.Type_d_envoi_prefere") }}</label>
        <ValidationProvider
          ref="vee-b-contact-contact_type"
          v-slot="{ errors, classes }"
          :name="'type d’envoi préféré'"
          rules="required"
        >
          <b-form-select
            :value="contact.contact_type"
            :options="contactTypeOptions"
            @change="updateContact('contact_type', $event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row class="mt-4 justify-content-end">
      <b-col cols="auto" class="mb-3">
        <div class="btn bg-color-green-light" :disabled="isLoadingSave" @click="createContact">
          <div class="color-white"><font-awesome-icon icon="check" /></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ContactORM from "@/store/orm-axios/models/Contact";
import { validate } from "vee-validate";
import meetingDetailsMixin from "@/mixins/meeting-details";

export default {
  mixins: [meetingDetailsMixin],
  props: {
    buildingId: {
      type: String,
      required: true,
    },
    agency: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      contact: {
        agency_id: this.agency,
        building_id: this.buildingId,
        address: "",
        zipcode: "",
        city: "",
        country: "FR",
        complement: "",
        complement2: "",
        entity_type: 1,
        contact_type: 1,
        can_vote: 0,
        gender: 1,
        firstname: "",
        lastname: "",
        email: "",
      },
      isLoadingSave: false,
      isEditMode: false,
    };
  },
  computed: {
    countryOptions() {
      let result = [];
      this.allCountries.forEach(element => {
        result.push({
          value: element.countryCode,
          text: element.countryName,
        });
      });
      return result;
    },
    allCountries() {
      return this.$store.getters.getCountries;
    },
  },
  created() {
    this.isCountryValid();
  },
  methods: {
    updateContact(key, value) {
      this.contact[key] = value;
    },
    setEntityType(type) {
      this.updateContact("entity_type", type);
      if (type == this.entityTypes.legal) {
        this.$emit("updateContact", "gender", 0);
        this.updateContact("gender", 0);
      }
    },
    isCountryValid() {
      let found = this.$_.find(this.allCountries, country => {
        return country.countryCode.toUpperCase() == this.contact.country.toUpperCase();
      });
      if (found === undefined) {
        this.updateContact("country", "");
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    async validateStep() {
      var valid = true;
      let values = [
        {
          key: "lastname",
          rules: "required",
        },
        {
          key: "email",
          rules: this.contact.contact_type == this.contactTypes.email ? "required" : "",
        },
      ];

      for (const value of values) {
        await validate(this.contact[value.key], value.rules, {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["vee-b-contact-" + value.key].validate();
          }
        });
      }
      return valid;
    },
    async createContact() {
      if (!(await this.validateStep())) {
        return;
      }
      this.CREATE_CONTACT();
    },
    CREATE_CONTACT() {
      ContactORM.insert({
        data: this.contact,
      }).then(res => {
        this.$emit("setContact", res.contacts[0]);
        this.setContactsData(this.buildingId);
        // NOTE: We allow this here, because is used in MeetingRegister
        this.setFreezedMeetingDetailsInMeeting(false);
      });
    },
  },
};
</script>
